export default "__VITE_ASSET__DARkfk8m__"